import React from "react";
import classes from './PatentAttestationDocumet.module.scss'
import Document from "../../../../components/Document";
export default function PatentAttestationDocumet() {
    return(
        <Document/>

    )
    
}